import { useTranslation } from 'react-i18next'
import React from 'react'

import { hasValue } from '../../../../../utils/helpers/value'
import { useForm, useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import ConditionItem from './ConditionItem'
import IconText from '../../../../../packages/kiti/components/presentation/IconText'
import Separator from '../../../../../packages/kiti/components/helpers/Separator'

const ConditionsSentence = () => {
  const { t } = useTranslation('triggers')
  const form = useForm()
  const conditions = form.conditions
  const { handleChange } = useFormState()

  if (!hasValue(conditions))
    return (
      <>
        <Separator weight={2} />
        <IconText
          color="dark4"
          label="Add condição"
          iconLeft="BsPlusCircle"
          onClick={() => handleChange('conditions', [{}])}
        />
      </>
    )

  return (
    <>
      {conditions.map((condition, index) => (
        <ConditionItem
          key={index}
          index={index}
          condition={condition}
          isLast={index + 1 === conditions.length}
          conditions={conditions}
        />
      ))}
    </>
  )
}

export default ConditionsSentence
